import { render, staticRenderFns } from "./CertificateMerge.vue?vue&type=template&id=7fae363c&scoped=true"
import script from "./CertificateMerge.vue?vue&type=script&lang=js"
export * from "./CertificateMerge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fae363c",
  null
  
)

export default component.exports